import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import PrivacyPolicyPage from '@components/privacy-policy-page/privacy-policy-page';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import { IUBENDA_PRIVACY_POLICY_URL } from '@libs/legal-documents';
import { getPrivacyPolicyHtml } from '@services/legal.service';

interface PrivacyPolicyProps {
  contentHtml: string | null;
  hostedDocumentUrl?: string;
}

const PrivacyPolicy: NextPage<PrivacyPolicyProps> = ({ contentHtml, hostedDocumentUrl }: PrivacyPolicyProps) => {
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Privacy Policy | Agilie',
          description:
            "Read Agilie's Privacy Policy. Learn how we collect, use, and protect your personal data when you interact with our website and services.",
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <MainLayout>
        <PrivacyPolicyPage contentHtml={contentHtml} hostedDocumentUrl={hostedDocumentUrl} />
      </MainLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<PrivacyPolicyProps> = async ({ res }) => {
  try {
    const contentHtml = await getPrivacyPolicyHtml();
    return {
      props: {
        contentHtml,
      },
    };
  } catch (error) {
    return {
      props: {
        contentHtml: null,
        hostedDocumentUrl: IUBENDA_PRIVACY_POLICY_URL,
      },
    };
  }
};

export default PrivacyPolicy;
